import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { RecordTypeActions, RecordTypeActionTypes } from './record-type.actions';
import { RecordTypeEntity } from './record-type.model';

export interface RecordTypeEntities extends EntityState<RecordTypeEntity> {
  // additional entities state properties
}

export const adapter: EntityAdapter<RecordTypeEntity> = createEntityAdapter<RecordTypeEntity>();

export const initialState: RecordTypeEntities = adapter.getInitialState({
  // additional entity state properties
});

export function reducer(state = initialState, incomingAction: Action): RecordTypeEntities {
  const action = incomingAction as RecordTypeActions;
  switch (action.type) {
    case RecordTypeActionTypes.AddRecordType: {
      return adapter.addOne(action.payload.recordType, state);
    }

    case RecordTypeActionTypes.UpsertRecordType: {
      return adapter.upsertOne(action.payload.recordType, state);
    }

    case RecordTypeActionTypes.AddRecordTypes: {
      return adapter.addMany(action.payload.recordTypes, state);
    }

    case RecordTypeActionTypes.UpsertRecordTypes: {
      return adapter.upsertMany(action.payload.recordTypes, state);
    }

    case RecordTypeActionTypes.UpdateRecordType: {
      return adapter.updateOne(action.payload.recordType, state);
    }

    case RecordTypeActionTypes.UpdateRecordTypes: {
      return adapter.updateMany(action.payload.recordTypes, state);
    }

    case RecordTypeActionTypes.DeleteRecordType: {
      return adapter.removeOne(action.payload.id, state);
    }

    case RecordTypeActionTypes.DeleteRecordTypes: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case RecordTypeActionTypes.LoadRecordTypes: {
      return adapter.setAll(action.payload.recordTypes, state);
    }

    case RecordTypeActionTypes.ClearRecordTypes: {
      return adapter.removeAll(state);
    }

    default: {
      return state;
    }
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
